import {
  HomeBanner,
  HomeContainer,
  HomeDivider,
  HomeFallbackCategories,
  HomeGenericCategories,
  HomeFilterableCategories,
  HomeFooter,
  HomeReorderRail,
  HomeOrderCard,
  HomeOrderBanner,
  HomeLoyaltyCard,
  HomePostOrderContent,
  HomeOrderCanceledBanner,
  HomeRateOrderCard,
  HomeLoading,
} from './components';

export const Home: {
  Container: typeof HomeContainer;
  Banner: typeof HomeBanner;
  OrderBanner: typeof HomeOrderBanner;
  OrderCanceledBanner: typeof HomeOrderCanceledBanner;
  PostOrderContent: typeof HomePostOrderContent;
  FallbackCategories: typeof HomeFallbackCategories;
  GenericCategories: typeof HomeGenericCategories;
  FilterableCategories: typeof HomeFilterableCategories;
  ReorderRail: typeof HomeReorderRail;
  LoyaltyCard: typeof HomeLoyaltyCard;
  OrderCard: typeof HomeOrderCard;
  RateOrderCard: typeof HomeRateOrderCard;
  Footer: typeof HomeFooter;
  Loading: typeof HomeLoading;
  Divider: typeof HomeDivider;
} = {
  Container: HomeContainer,
  Banner: HomeBanner,
  OrderBanner: HomeOrderBanner,
  OrderCanceledBanner: HomeOrderCanceledBanner,
  PostOrderContent: HomePostOrderContent,
  FallbackCategories: HomeFallbackCategories,
  GenericCategories: HomeGenericCategories,
  FilterableCategories: HomeFilterableCategories,
  ReorderRail: HomeReorderRail,
  LoyaltyCard: HomeLoyaltyCard,
  OrderCard: HomeOrderCard,
  RateOrderCard: HomeRateOrderCard,
  Footer: HomeFooter,
  Loading: HomeLoading,
  Divider: HomeDivider,
};
